module.exports = __webpack_public_path__ + "img/Facebook_icon_2013.bfa47fd4.svg";